import styled, { css } from 'styled-components';
import CompanyLogoMap from './helpers/CompanyLogoMap';
import { createElement } from 'react';

const Wrapper = styled.span`
  display: flex;

  ${({ isWhite }) =>
    isWhite &&
    css`
      svg * {
        fill: white !important;
      }
    `};
`;

/**
 * @param {CompanyLogoProps} props
 * @returns {React.ReactElement} The rendered component
 */
const CompanyLogo = ({
  logo,
  className,
  hovered,
  white = false,
  onClick = () => {},
}) => {
  return (
    <Wrapper onClick={onClick} isWhite={white} data-id={logo}>
      {createElement(CompanyLogoMap[logo] || CompanyLogoMap.DEFAULT, {
        hovered,
        className,
      })}
    </Wrapper>
  );
};

export default CompanyLogo;
